import { z } from 'zod';
/** Schema for login credentials. */
export const loginSchema = z.object({
    email: z
        .string({ required_error: 'Email is required' })
        .email('Please enter a valid email address')
        .max(255, 'Email must be 255 characters or fewer')
        .transform((v) => v.toLowerCase().trim()),
    password: z
        .string({ required_error: 'Password is required' })
        .min(1, 'Password is required'),
});
/** Schema for new user registration. */
export const registerSchema = z.object({
    email: z
        .string({ required_error: 'Email is required' })
        .email('Please enter a valid email address')
        .max(255, 'Email must be 255 characters or fewer')
        .transform((v) => v.toLowerCase().trim()),
    password: z
        .string({ required_error: 'Password is required' })
        .min(8, 'Password must be at least 8 characters')
        .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
        .regex(/[0-9]/, 'Password must contain at least one number'),
    firstName: z
        .string({ required_error: 'First name is required' })
        .min(1, 'First name is required')
        .max(100, 'First name must be 100 characters or fewer')
        .trim(),
    lastName: z
        .string({ required_error: 'Last name is required' })
        .min(1, 'Last name is required')
        .max(100, 'Last name must be 100 characters or fewer')
        .trim(),
});
/** Schema for changing a password. */
export const changePasswordSchema = z
    .object({
    oldPassword: z
        .string({ required_error: 'Current password is required' })
        .min(1, 'Current password is required'),
    newPassword: z
        .string({ required_error: 'New password is required' })
        .min(8, 'New password must be at least 8 characters')
        .regex(/[A-Z]/, 'New password must contain at least one uppercase letter')
        .regex(/[a-z]/, 'New password must contain at least one lowercase letter')
        .regex(/[0-9]/, 'New password must contain at least one number'),
    confirmPassword: z
        .string({ required_error: 'Password confirmation is required' })
        .min(1, 'Please confirm your new password'),
})
    .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
})
    .refine((data) => data.oldPassword !== data.newPassword, {
    message: 'New password must be different from the current password',
    path: ['newPassword'],
});
/** Schema for MFA verification (6-digit TOTP code). */
export const mfaVerifySchema = z.object({
    code: z
        .string({ required_error: 'Verification code is required' })
        .regex(/^\d{6}$/, 'Verification code must be exactly 6 digits'),
});
//# sourceMappingURL=auth.js.map